/**
 * Single source of truth for postal-code validation rules per country.
 *
 * The {@link PostalCodeValidator} looks up the rule for its configured country
 * and validates a (normalized) postal code against `regex`. `example` is used to
 * build a helpful default error message.
 */
export interface PostalCodeRule {
  regex: RegExp;
  example: string;
}

const POSTAL_CODE_RULES: Record<string, PostalCodeRule> = {
  // Dutch postal code: four digits not starting with 0, followed by two letters,
  // with optional whitespace in between (e.g. "1234 AB" or "1234AB").
  NL: {
    regex: /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/,
    example: "1234 AB",
  },
};

/**
 * Return the postal-code rule for the given country code (case-insensitive), or
 * `undefined` when no rule is defined for that country.
 */
export const getPostalCodeRule = (
  country: string | null | undefined,
): PostalCodeRule | undefined =>
  POSTAL_CODE_RULES[(country ?? "").toUpperCase()];
